import React from 'react';
import '@assets/sass/components/_primary-box.scss';

export default ({heading, children, className, noPadding, passRef}) => (
    <div data-testid="primary-box"
         className={className ? className + ' primary-box primary-box--no-padding' : ' primary-box primary-box--no-padding'}
         ref={passRef && passRef}
    >
        {heading &&
        <header className="primary-box__heading" data-testid="primary-box-heading">
            <h2>{heading}</h2>
        </header>
        }

        <div className={"primary-box__content " + (noPadding ? " primary-box__content--no-padding " : " ")}>
            {children}
        </div>
    </div>
)
